import { request } from '../request';

export const localModelApi = {
  listLocalModels: (backend) => {
    const params = backend ? `?backend=${encodeURIComponent(backend)}` : '';
    return request(`/local-models${params}`);
  },

  downloadModel: (body) =>
    request('/local-models/download', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  getDownloadStatus: (backend) => {
    const params = backend ? `?backend=${encodeURIComponent(backend)}` : '';
    return request(`/local-models/download-status${params}`);
  },

  cancelDownload: (taskId) =>
    request(`/local-models/cancel-download/${encodeURIComponent(taskId)}`, { method: 'POST' }),

  deleteLocalModel: (modelId) => request(`/local-models/${encodeURIComponent(modelId)}`, { method: 'DELETE' })
};
